import { render } from "./Watch.vue?vue&type=template&id=54f9729d&scoped=true"
import script from "./Watch.vue?vue&type=script&lang=js"
export * from "./Watch.vue?vue&type=script&lang=js"

import "./Watch.vue?vue&type=style&index=0&id=54f9729d&lang=css"
import "./Watch.vue?vue&type=style&index=1&id=54f9729d&scoped=true&lang=css"

import exportComponent from "C:\\AOTCHRON\\AOTCHRON\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54f9729d"]])

export default __exports__